/* eslint-disable no-param-reassign */
/* eslint-disable no-await-in-loop */
/* eslint-disable @typescript-eslint/no-inferrable-types */
export interface ITokenResData {
  access_token: string;
  refresh_token: string;
  uid: string;
  scope: string;
  token_type: string;
  exp: string;
  iat: string;
  expires_in: string;
}
export class TokenManager {
  private refreshThreshold: number;
  private isRefreshTokenExpired: boolean;
  private prefixUrl: string;
  private callbackEndpoint: string = '/oauth2/callback';
  private refreshEndpoint: string = '/oauth2/token';
  private sdk_token: string;
  private timer: ReturnType<typeof setTimeout> | undefined;
  private updateAccessTokenFn: Function;
  private localKey: string;

  constructor(prefixUrl: string, updateAccessTokenFn: Function, localKey: string, sdk_token: string) {
    this.refreshThreshold = 15 * 1;
    this.isRefreshTokenExpired = false;
    this.prefixUrl = prefixUrl;
    this.timer = undefined;
    this.updateAccessTokenFn = updateAccessTokenFn;
    this.localKey = localKey;
    this.sdk_token = sdk_token;

    this.fetchNewAccessToken();
  }

  getAccessToken(): string {
    return this.getFromLocal().access_token;
  }

  getOriginData(): ITokenResData {
    return this.getFromLocal();
  }

  /**
   * 过期时间小于20s，不重试
   * 过期时间大于设定时间，则取15s和expire - this.refreshThreshold的大值
   * @param expires_in
   */
  genAutoRefresh(expires_in: number) {
    clearTimeout(this.timer);
    let _time = this.refreshThreshold;
    const _expire = Number(expires_in);

    if (_expire <= _time + 5) {
      return;
    } else {
      _time = Math.max(_expire - this.refreshThreshold, _time);
    }

    console.log('重试时间', _time);

    this.timer = setTimeout(() => {
      this.refreshTokenWithRetry();
    }, _time * 1000);
  }

  async getAuth(params: { code: string; nonce: string; state: string }): Promise<void> {
    clearTimeout(this.timer);

    try {
      const { code, nonce, state } = params;
      const response = await fetch(
        `${this.prefixUrl}${this.callbackEndpoint}?code=${code}&nonce=${nonce}&state=${state}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        },
      );

      if (response.status === 200) {
        const res = await response.json();

        this.isRefreshTokenExpired = false;
        this.updateAccessTokenFn && this.updateAccessTokenFn(res.access_token);
        this.genAutoRefresh(Number(res.expires_in));
        this.setToLocal(res);
        return res;
      } else {
        const res = await response.text();
        console.log('getauth error', res);
        this.isRefreshTokenExpired = true;
      }
    } catch (error) {
      console.error('Failed to fetch access_token:', error);
    }
  }

  async refreshTokenWithRetry(): Promise<void> {
    if (this.isRefreshTokenExpired) {
      return;
    }

    await this.fetchNewAccessToken();
  }

  fetchNewAccessToken = async () => {
    try {
      const localData = this.getFromLocal();
      const { refresh_token, uid } = localData;

      if (!(refresh_token && uid)) {
        return null;
      }
      console.log('refresh_token: fetch');
      const response = await fetch(
        `${this.prefixUrl}${this.refreshEndpoint}?refresh_token=${refresh_token}&uid=${uid}&grant_type=refresh_token&sdk_token=${this.sdk_token}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      const res = await response.json();
      const { access_token, expires_in } = res;

      this.isRefreshTokenExpired = false;
      this.updateAccessTokenFn && this.updateAccessTokenFn(res.access_token);
      this.genAutoRefresh(Number(res.expires_in));
      this.setToLocal(res);

      return { access_token, expires_in };
    } catch (error) {
      const data: any = {};
      this.setToLocal(data);
      console.error('Failed to refresh access_token:', error);
      return null;
    }
  };

  clearLocal() {
    localStorage.removeItem(this.localKey);
  }

  private setToLocal(data: ITokenResData) {
    localStorage.setItem(this.localKey, JSON.stringify(data));
  }

  private getFromLocal() {
    return JSON.parse(localStorage.getItem(this.localKey) || '{}');
  }
}
